var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0976 32.3791V28.0865M31.0976 24.1841V28.0865M26.805 28.0865H31.0976M35 28.0865H31.0976M4.17082 15.599H17.0487L22.9026 15.5988L30.7072 15.599V10.9161H4.17082V15.599ZM4.17082 15.599L9.63419 13.2575H4.9513L16.2683 12.0868H23.6828H28.3657V14.4283H9.63419M31.0976 18.7209V9.74525C31.0976 7.99681 31.0976 5.84285 31.0976 5.84285C31.0976 4.67222 28.3659 5.06247 27.5854 5.06237C26.805 5.06227 24.651 5.06233 22.9026 5.06233H7.2149C5.46646 5.06233 4.56086 5.0625 3.78038 5.06239C3.19295 5.3617 2.99998 5.84298 3.00019 6.62346C3.00039 7.40394 3.0003 8.77738 3.0003 10.5258L3.0001 21.8428C3.0001 23.5913 3.0002 26.1355 3.0001 26.5257C3 26.916 3.78058 28.0865 4.56106 28.0865C5.73178 28.0865 9.05647 28.0865 10.8049 28.0865H21.7316",
    stroke: "#8A96A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/Add_card.9c50c4bc371d774da27e3baab34e86a6.svg";
export { ForwardRef as ReactComponent };